import { gql } from '@apollo/client';

export const SEARCH_COOPERATION_WAREHOUSES_FOR_APPOINTMENT = gql`
  query SearchCooperationWarehousesForAppointment($name: String!, $warehouseId: Long!) {
    searchCooperationWarehousesForAppointment(name: $name, warehouseId: $warehouseId) {
      cooperationWarehouseId
      cooperationWarehouseName
      contactName
      contactPhone
      countryCode
      contactEmail
      ext
      addressLine1
      addressLine2
      country
      state
      city
      zipcode
      workWeekdaysJson
      workStartTime
      workEndTime
      remark
    }
  }
`;

export const GET_COOPERATION_WAREHOUSE_FOR_APPOINTMENT = gql`
  query getCooperationWarehouseForAppointment($cooperationWarehouseId: Long!) {
    getCooperationWarehouseForAppointment(cooperationWarehouseId: $cooperationWarehouseId) {
      cooperationWarehouseId
      cooperationWarehouseName
      contactName
      contactPhone
      countryCode
      contactEmail
      ext
      addressLine1
      addressLine2
      country
      state
      city
      zipcode
      workWeekdaysJson
      workStartTime
      workEndTime
      remark
    }
  }
`;

export interface CooperationWarehouseForAppointment {
  cooperationWarehouseId: number;
  cooperationWarehouseName: string;
  contactName?: string;
  contactPhone?: string;
  countryCode: number;
  contactEmail?: string;
  ext?: string;
  addressLine1: string;
  addressLine2?: string;
  country: string;
  state?: string;
  city?: string;
  zipcode?: string;
  workWeekdaysJson: number[];
  workStartTime: string;
  workEndTime: string;
  remark?: string;
}

export interface SearchCooperationWarehousesForAppointmentResponse {
  searchCooperationWarehousesForAppointment: CooperationWarehouseForAppointment[];
}

export interface SearchCooperationWarehousesForAppointmentVariables {
  name: string;
  warehouseId: string;
}

export interface GetCooperationWarehouseByIdResponse {
  getCooperationWarehouseForAppointment: CooperationWarehouseForAppointment;
}

export interface GetCooperationWarehouseByIdVariables {
  cooperationWarehouseId: number;
}